import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_col = _resolveComponent("v-col");
    const _component_OrderDetailBaromoneyRemittanceInProgress = _resolveComponent("OrderDetailBaromoneyRemittanceInProgress");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_card_actions = _resolveComponent("v-card-actions");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_row = _resolveComponent("v-row");
    return (_openBlock(), _createBlock(_component_v_card, {
        flat: "",
        tile: "",
        class: "pa-0",
        "min-height": "252"
    }, {
        default: _withCtx(() => [
            _createCommentVNode(" 출발지 정보 "),
            (!_ctx.isQuick)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_pickup_info.store_name')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                    flat: "",
                                    tile: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createCommentVNode(" 상점명 "),
                                        _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular text-black pa-0" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.storeName), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createCommentVNode(" 상점 바로머니 송금 "),
                                        (!_ctx.isHQ && _ctx.isShowRemittanceBaromoneyBtn)
                                            ? (_openBlock(), _createBlock(_component_v_card_actions, {
                                                key: 0,
                                                class: "d-block pa-0 pt-3"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createCommentVNode(" 송금 다이얼로그 "),
                                                    _createVNode(_component_OrderDetailBaromoneyRemittanceInProgress, {
                                                        "delivery-id": _ctx.deliveryId,
                                                        "is-pickup-info-card": true
                                                    }, null, 8 /* PROPS */, ["delivery-id"]),
                                                    (_ctx.isMobile)
                                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 0,
                                                            variant: "outlined",
                                                            color: "blue-grey darken-1",
                                                            href: `tel:${_ctx.storePhone}`,
                                                            class: "me-1",
                                                            width: _ctx.buttonWidth
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('common.phone')), 1 /* TEXT */)
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["href", "width"]))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                _: 1 /* STABLE */
                                            }))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 상점 전화번호 "),
            (!_ctx.isQuick)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    class: "mt-4",
                    "no-gutters": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_pickup_info.store_phone_number')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.storePhoneWithHypen), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 출발지 메모 "),
            _createVNode(_component_v_row, {
                "no-gutters": "",
                class: _normalizeClass([_ctx.storeMemoPosition, "mt-4"])
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_pickup_info.store_memo')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.checkEmptyString(_ctx.storeMemo)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["class"]),
            _createCommentVNode(" 출발지 주소 "),
            _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-4"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_pickup_info.pickup_address')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.pickupAddressShorten), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }),
            _createCommentVNode(" 발주허브명 "),
            _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-4"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_pickup_info.ordering_hub_name')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.hubName), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }));
}
